module.exports = __webpack_public_path__ + "static/datamanNext-7ffcf20144320ae0a2308ce94d828b56.png";